 const API_KEY = "AIzaSyAYVNLlMvHEBxUlFCrQU9MJiKgC4KwmxN4";
 export default API_KEY;